module.exports = __webpack_public_path__ + "static/media/189-equatorial-guinea.e4834f6e.svg";